// import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '../src/assets/css/index.css'
import liff from '@line/liff'

async function initLiff () {
  // localStorage.setItem('displayName', 'Agnes')
  // localStorage.setItem('userId', 'U1e8aa9c0338061ea3ad4b4ff3ca72895')
  // localStorage.setItem('pictureUrl', 'https://profile.line-scdn.net/0hGSIVqpS5GHxkLwlFwyFmAxR_GxZHXkFuSkkAGll_RxsJTFwvTUsDSgUsRkRQHlZ-HRpUHVksQBtoPG8aennkSGMfRkteH1orSU5VnA')
  try {
    await liff.init({ liffId: '1661400637-Gvq3v5rd' })

    if (liff.isLoggedIn()) {
      const profile = await liff.getProfile()
      localStorage.setItem('displayName', profile.displayName)
      localStorage.setItem('userId', profile.userId)
      localStorage.setItem('pictureUrl', profile.pictureUrl)
    } else {
      const path = window.location.hash.replace('#', '')
      const redirectUri = path.includes('exchange')
        ? 'https://csai.uupon.com/#/exchange'
        : path.includes('wallet') ? 'https://csai.uupon.com/#/wallet' : 'https://csai.uupon.com/#/'

      console.log('Redirecting to:', redirectUri)
      liff.login({ redirectUri: redirectUri })
    }
  } catch (error) {
    console.error('LIFF 初始化失敗:', error)
  }
}

// 先初始化 LIFF，再啟動 Vue
initLiff().then(() => {
  createApp(App).use(store).use(router).mount('#app')
})
